import React from 'react';
import useAuth from '../context/useAuth';
import MemberSummaryDashboard from '../components/MemberSummaryDashboard.js';
import SummaryDashboard from '../components/ReceiptDonationsSummaryDashboard.js';

const Home = () => {
  const { role } = useAuth();

  return (
    <div className="container">
      <div>
        {role !== 'member' ? (
          <div className="mt-4">
            <SummaryDashboard />
          </div>
        ) : (
          <div className="mt-4">
            <MemberSummaryDashboard />
            <SummaryDashboard />
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;